module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"mortgage":"Hipotecario","complementary":"Complementario","homeEquity":"Hipotecario","parking":"","sme":"SME"},"pe":{"mortgage":"Hipotecario","complementary":"Complementario","homeEquity":"Hipotecario","parking":"","sme":"SME"},"br":{"mortgage":"Hipoteca","complementary":"Complementar","homeEquity":"Hipoteca","parking":"","sme":"SME"}}')
  delete Component.options._Ctor
}
